// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"557":"8686530c","748":"38c0a835","925":"462f9d04"}[chunkId] + ".chunk.js";
};